module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch4"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage3"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch4.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-4"
    }
  }, [_vm._v("You crouch over the crack. Your bat sonar tells you that it goes down a long, long way. It might even go on forever. And you’re almost afraid to imagine what you might find inside it.")])]), _c('a', {
    attrs: {
      "id": "pg-4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, you’re a bat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You’re trapped in the crypt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What have you got to lose?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You take a deep breath to calm yourself. You do a couple of warm-up flaps of your wings. Then, before you can change your mind, you dive head-first into the crack. But you’re no longer flying!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Instead, you’re falling, falling straight down. What are you doing wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In a panic, you check out your wings. To your amazement, they’re gone! Those are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("arms")]), _vm._v(" flailing around. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Your")]), _vm._v(" arms. You’re a kid again!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You don’t have time to celebrate. You’re falling faster now. And faster. Will you ever land? And will you survive the crash? And if you do, where will you be?")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quick! Turn to ")])]), _c('span', {
    attrs: {
      "href": "#/e9780545841030_ch135",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 135")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da2ad50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841030_ch004.vue
// module id = 75
// module chunks = 0